import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class CompaniesAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name'
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_number'
      },
      {
        title: 'Fax Number',
        dataIndex: 'fax_number'
      },
      {
        title: 'Address',
        dataIndex: 'address'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { companiesAddedData } = this.props

    const data = companiesAddedData.map((organization, index) => {
      organization.created_date = moment(new Date(organization.created_date)).format(
        'YYYY-MM-DD h:mm a'
      )

      // format address
      organization.address = `${organization.address1 !== null && organization.address1}${
        organization.address2 !== null ? ' ' + organization.address2 : ''
      }${organization.city !== null ? ', ' + organization.city : ''}${
        organization.state !== null ? ' - ' + organization.state : ''
      }${organization.zip !== null ? ' - ' + organization.zip : ''}`

      const returnObj = Object.assign({ key: `${organization.id}${index}` }, organization)
      delete returnObj.id
      return returnObj
    })
    return data
  }

  render() {
    const { loadingCompaniesAdded, companiesAddedData } = this.props
    return (
      <div>
        {loadingCompaniesAdded && !companiesAddedData && <Spin />}
        {!loadingCompaniesAdded &&
          companiesAddedData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default CompaniesAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/CompaniesAdded.js